// extracted by mini-css-extract-plugin
export default {"PFSBreadCrumb":"PFSBreadCrumb_PFSBreadCrumb__icfI4"};